import { render, staticRenderFns } from "./AzPersonsOtherIdsReadOnlyPanel.vue?vue&type=template&id=11f3fcda"
import script from "./AzPersonsOtherIdsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./AzPersonsOtherIdsReadOnlyPanel.vue?vue&type=script&lang=js"
import style0 from "./AzPersonsOtherIdsReadOnlyPanel.vue?vue&type=style&index=0&id=11f3fcda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports